import { apiKeysRoutes } from "@/pages/api-keys/routes";
import { homeRoutes } from "@/pages/home/routes";
import { permissionGroupsRoutes } from "@/pages/permission-groups/routes";
import { stringsRoutes } from "@/pages/strings/routes";
import { usersRoutes } from "@/pages/users/routes";
import type { NavigationRoute } from "@/types/navigation-route";

export const appRoutes: NavigationRoute[] = [
  ...homeRoutes,
  ...permissionGroupsRoutes,
  ...usersRoutes,
  ...apiKeysRoutes,
  ...stringsRoutes,
];
